import { type FieldTypeConfig, JsonSchemaType } from './types';

export const tags: FieldTypeConfig = {
  toJsonSchema: () => ({
    type: JsonSchemaType.Array,
  }),
};
